import { gql } from '@apollo/client';
import { NamedFilterFragment } from './fragments';

export const GET_NAMED_FILTER = gql`
  query GetNamedFilter($id: ID!) {
    namedFilter(id: $id) {
      ...NamedFilterFields
    }
  }
  ${NamedFilterFragment}
`;

export const NAMED_FILTER_ADD_CATEGORY = gql`
  mutation NamedFilterAddCategory($input: NamedEntityEditCategoryInput!) {
    namedFilterAddCategory(input: $input) {
      message
      errors {
        field
        messages
      }
    }
  }
`;

export const NAMED_FILTER_REMOVE_CATEGORY = gql`
  mutation NamedFilterRemoveCategory($input: NamedEntityEditCategoryInput!) {
    namedFilterRemoveCategory(input: $input) {
      message
      errors {
        field
        messages
      }
    }
  }
`;
